class Repository {
    constructor() {
        this.endpoint = window.akita.urls.api + "/v1/me/dashboards";
    }

    index(request) {
        return axios.get(this.endpoint, request);
    }

    show(id, request) {
        return axios.get(this.endpoint + "/" + id, request);
    }
}

module.exports = Repository;
